import { devices } from "src/utils/styled/_variables.styled";
import styled from "styled-components";

interface IconListContainerProps {
    itemCount: number;
}

export const CardWrapper = styled.div`
    width: 100%;
    min-height: 336px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;

     @media ${devices.mfDesktop} {
            min-height: 438px;
        }
`;

export const IconList = styled.div<IconListContainerProps>`
    display: flex;
    justify-content: ${({ itemCount }) =>
        itemCount === 1 ? 'center' : 'space-between'};
    gap: 8px;
`;

export const IconWrapper = styled.div`
    background-color: rgba(245, 245, 245, 1);
    padding: 8px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;


    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
`;

export const TextList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .text-item {
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const PercentageBadge = styled.div`
    background-color: rgba(197, 164, 248, 1);
    color: rgba(25, 25, 25, 1);
    padding: 4px 8px;
    border-radius: 500px;
    display: inline-block;
    min-width: 40px;
    text-align: center;
`;